import type { Vec2 } from "./20thCenturyFox";

// Helper to get a random index different from the current one
export const getRandomOtherIndex = (current: number, total: number) => {
  let idx = Math.floor(Math.random() * (total - 1));
  if (idx >= current) idx += 1;
  return idx;
};

// Helper to calculate squared distance between two nodes
export const dist2 = (a: Vec2, b: Vec2) => (a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y);
